<template>
	<div class="content-zsy">
		<div class="title-wrap">
			<h3>개인정보처리방침</h3>
		</div>
		<div class="terms-content">
            <p>
                ㈜고로켓고(이하 “회사”)은 이용자의 개인정보를 중요하게 생각하며 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 및 관련 법령을 준수합니다.
                본 개인정보처리방침은 회사가 운영하는 고로켓고(http://goroketgo.com)서비스 이용 시 이용자의 개인정보가 어떠한 방식으로 수집·이용·보관·관리되는지를 안내합니다.
                이용자는 본 서비스를 이용하기 전에 본 개인정보처리방침을 확인하시기 바랍니다.
            </p>

            <strong>1. 수집하는 개인정보 항목</strong>
            <p>회사는 회원가입 및 서비스 제공을 위해 다음과 같은 개인정보를 수집합니다.</p>
            <p>① 개인 회원<br>·성명(국문/영문)·아이디·비밀번호·이메일·주소·전화번호·휴대전화번호·생년월일·성별</p>
            <p>② 사업자 회원<br>·이름(국문/영문)·상호 또는 법인명(국문/영문)·아이디·비밀번호·이메일·사업장 주소 및 국적·판매몰 정보 및 운영 웹사이트 URL·전화번호·휴대전화번호·생년월일 또는 법인 설립일·성별</p>
            <p>③ 서비스 이용 과정에서 자동 수집되는 정보<br>·서비스 이용기록·접속 로그·IP 주소·쿠키(Cookie)·불량 이용 기록</p>
            <p>④ 유료 서비스 이용 시<br>·카드 결제정보(카드사명, 카드 소유자명, 카드번호 일부, 유효기간 등)</p>

            <strong>2. 개인정보 수집 방법</strong>
            <p>회사는 다음과 같은 방법으로 개인정보를 수집합니다.<br>·홈페이지 회원가입·배송신청 및 서비스 신청·고객 상담(전화, 이메일, 게시판)·이벤트 참여·자동 생성 정보 수집 도구·제휴 또는 협력사 제공</p>

            <strong>3. 개인정보 이용 목적</strong>
            <p>수집된 개인정보는 다음 목적을 위해 사용됩니다.</p>
            <p>① 서비스 제공 및 요금 정산<br>·상품 배송 및 국제운송 서비스 제공·본인 확인·결제 처리 및 요금 정산</p>
            <p>② 회원 관리<br>·회원 식별 및 가입 의사 확인·부정 이용 방지·고객 문의 및 민원 처리·통관 관련 정보 안내</p>
            <p>③ 서비스 개선 및 마케팅<br>·서비스 이용 통계 분석·신규 서비스 개발·이벤트 및 안내 정보 제공</p>

            <strong>4. 개인정보 보유 및 이용기간</strong>
            <p>회사는 개인정보 수집 및 이용 목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 다만 다음의 경우 일정 기간 보관할 수 있습니다.</p>
            <p>① 내부 정책에 따른 보관<br>·보관항목: ID, 생년월일, 이메일·보관목적: 부정 이용 방지·보관기간: 1년</p>
            <p>② 관계 법령에 따른 보관<br>·서비스 이용기록, 접속기록, IP 정보·보관기간: 3개월·근거법령: 통신비밀보호법</p>

            <strong>5. 개인정보 수집 및 이용 동의</strong>
            <p>회사는 개인정보 수집 및 이용에 대해 이용자의 동의를 받습니다. 회원가입 과정에서 “동의” 버튼을 클릭하는 경우 개인정보 수집 및 이용에 동의한 것으로 간주됩니다.</p>

            <strong>6. 쿠키(Cookie)의 사용</strong>
            <p>회사는 이용자 편의를 위해 쿠키를 사용할 수 있습니다.</p>
            <p>쿠키 사용 목적<br>·이용자의 접속 빈도 및 방문 시간 분석·맞춤형 서비스 제공·이벤트 및 마케팅 활용</p>
            <p>쿠키 설정 거부 방법<br>이용자는 웹 브라우저 설정을 통해 쿠키 저장을 거부할 수 있습니다.<br>예)브라우저 설정 → 개인정보 → 쿠키 차단<br>단, 쿠키 저장을 거부할 경우 일부 서비스 이용이 제한될 수 있습니다.</p>

            <strong>7. 개인정보 제공 및 공유</strong>
            <p>회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다. 다만 다음의 경우에는 예외로 합니다.<br>·이용자가 사전에 동의한 경우·법령에 따라 제공이 필요한 경우·수사기관의 법적 요청이 있는 경우·배송 및 서비스 제공을 위해 필요한 최소 범위의 정보 제공</p>

            <strong>8. 개인정보 보호</strong>
            <p>회사는 개인정보의 분실, 도난, 유출, 변조 또는 훼손을 방지 위해 기술적·관리적 보호 조치를 시행하고 있습니다. 다만 이용자의 부주의로 발생한 개인정보 유출에 대해서는 회사가 책임을 지지 않습니다.</p>

            <strong>9. 개인정보 관리책임자</strong>
            <p>개인정보 보호 관련 문의는 아래 담당자에게 연락하시기 바랍니다.</p>
            <p>개인정보 관리책임자<br>이름 : 정원교<br>전화 : 1566-0909<br>이메일 : cs@goroketgo.com</p>

            <strong>10. 개인정보처리방침 변경</strong>
            <p>본 개인정보처리방침은 관련 법령 또는 회사 정책에 따라 변경될 수 있으며, 변경 시 사이트 공지사항을 통해 안내합니다.</p>
		</div>
	</div>
</template>

<script>
export default {
    name: 'PrivacyPolicy'
}
</script>

<style scoped>
	.title-wrap {
	    text-align: center;
	    color: var(--frontground-color);
	    margin: 60px 0;
	}
	.title-wrap h3 {
	    font-size: 45px;
	    font-weight: bold;
	}
    .terms-content {
        line-height: 1.8;
        color: #333;
        font-size: 16px;
    }
    .terms-content p {
        margin-bottom: 10px;
    }
    .terms-content strong {
        display: block;
        font-size: 18px;
        margin-top: 20px;
        margin-bottom: 10px;
    }
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.content-zsy{
			margin: 30px 10px;
		}
	}
</style>